'use strict'
const autoThumbnailBreakpoint = 1024
const scrollTo = require('../script/animate-scroll-to.js')

module.exports = () => {
	// On thumbnail click
	const thumnailEl = document.querySelectorAll('.thumbnails a:not(.processed)')
	for(let i = thumnailEl.length; i--;){
		thumnailEl[i].classList.add('processed')
		thumnailEl[i].addEventListener('click', onThumbnailClick)
	}

	// Auto click if mobile
	const thumbnails = document.querySelectorAll('.thumbnails:not(.processed)')
	for(let i = thumbnails.length; i--;){
		thumbnails[i].classList.add('processed')
		const els = thumbnails[i].querySelectorAll('a')
		let active = 0
		setInterval(() => {
			if(getWidth() >= autoThumbnailBreakpoint) return
			active++
			if(active >= els.length){
				active = 0
			}
			els[active].click()
		}, 3000)
	}
}


function getWidth(){
	return Math.max(document.documentElement.clientWidth, window.innerWidth || 0)
}

function onThumbnailClick(e){
	e.preventDefault()

	// Scroll
	const thumbnails = this.parentElement
	if(thumbnails){
		let target = this.offsetTop
		target = target - (thumbnails.clientHeight / 2)
		target = target + (this.clientHeight / 2)
		//thumbnails.scrollTop = target
		new scrollTo({
			element: thumbnails,
			y: target
		})
	}

	// Replace main image
	const mainImg = thumbnails.parentElement.querySelector('.mainImg img')
	if(mainImg){
		mainImg.src = this.href
	}
}
